import styled from 'styled-components';
import { Text, FlexContainer } from '@taxdown/piccolo-web';

export const StyledContainer = styled(FlexContainer)`
  border-top: 1px solid ${({ theme: { colors } }) => colors.moon_500};
  margin-bottom: ${({ theme: { reference } }) => reference.dimension_32};
`;

export const StyledFlexContainer = styled(FlexContainer)`
  border-bottom: 1px solid ${({ theme: { colors } }) => colors.moon_500};
  padding: 1rem 0;
`;

export const NotificationGroupTitle = styled(Text)`
  ${({ theme: { typography } }) => typography.fds_text_regular_L};
  background: ${({ theme: { colors } }) => colors.moon_300};
  padding: ${({ theme: { sizing } }) => `${sizing.fds_size_08} ${sizing.fds_size_24}`};
`;
